import axios from 'axios';
import AppConfig from '../AppConfig';
import setupInterceptors from './setupInterceptor';

const telehealthAxiosInstance = axios.create({
  baseURL: AppConfig.TELEHEALTH_BASE_URL as string,
  // headers: {
  //   'x-plum-token':
  //     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZW1iZXJJZCI6IjlnbDgxZEhTM2hRWDZVMGFFYXBuIiwib3JnYW5pc2F0aW9uSWQiOiJETm9EM0FsNjU2ajBBNHpiaVBDaSIsInNvdXJjZSI6Ik1FTUJFUlMiLCJlbWFpbElkIjoiZ2F1cmF2QHBsdW1ocS5jb20iLCJpYXQiOjE2ODYxMzU0MjUsImV4cCI6MTcyMzgxMzU0MjV9.VXq7AErNSQ2EiTg4ifRmNFYouNdKVJ_20wNRu9OpZ98',
  // },
});

setupInterceptors(telehealthAxiosInstance)

export default telehealthAxiosInstance;
